import ArtDirectedImage from '@/components/Image/ArtDirectedImage';
import useStyles from '@/components/MediaOverlay/MediaOverlay.styles';
import type { IImageOverlay } from '@/components/MediaOverlay/types';

export default function ImageOverlay({
  images,
  darken,
  className,
  overlayClassName,
  ...htmlProps
}: IImageOverlay) {
  const { classes, cx } = useStyles({ darken, isThumbnailVisible: true });

  return (
    <div className={cx(classes.relative, className)} {...htmlProps}>
      <div className={cx(classes.relative, overlayClassName)}>
        {images?.fallback[0] && (
          <ArtDirectedImage
            alt='presentation'
            images={images}
            pictureProps={{
              className: cx(classes.image, classes.imageZ),
            }}
            data-testid='image-overlay'
          />
        )}
      </div>
      <div className={cx(classes.overlayContent, classes.overlayContentZ)}>
        {htmlProps.children}
      </div>
    </div>
  );
}
